import e from "./index.ce.vue.js";
import { defineAndRegisterElement as t } from "../../utils/register-element.js";
const m = t(e);
export {
  m as initManageMentList
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/manage-mentList/index.js
// module id = 1268
// module chunks = 41